import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchCurrentPage: {
		id: 'filter-refinement.search-field.keyboard-shortcuts.search-current-page',
		defaultMessage: 'Search on current page',
		description: 'Command in the command palette to trigger the page search',
	},
});
